import { render, staticRenderFns } from "./TrendArea.vue?vue&type=template&id=62e752a1&"
import script from "./TrendArea.vue?vue&type=script&lang=js&"
export * from "./TrendArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports